export enum ErrorCode {
  // https://eips.ethereum.org/EIPS/eip-1193#provider-errors
  USER_REJECTED_REQUEST = 4001,

  // https://docs.metamask.io/guide/rpc-api.html#unrestricted-methods
  CHAIN_NOT_ADDED = 4902,
  CHAIN_NOT_ADDED_MOBILE_APP = -32000,

  // https://eips.ethereum.org/EIPS/eip-1474#error-codes
  INTERNAL_JSON_RPC_ERROR = -32603,

  // Ethers errors
  INSUFFICIENT_OUTPUT_AMOUNT = 'INSUFFICIENT_OUTPUT_AMOUNT',

  // Custom errors
  DEFAULT_CONFIRM_SWAP_ERROR = 'DEFAULT_CONFIRM_SWAP_ERROR',
}
